import kg from './locales/kg.json'
import ru from './locales/ru.json'
import en from './locales/en.json'
const messages = {en, ru, kg}
export default messages
